<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-12-26 15:40:16
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2026-09-03 10:43:35
 -->
<template>
  <div class="ui-footer posfix">
    <!-- <div class="ui-footer-mask wh100"></div> -->
    <div class="container wh100 posabs">
      <div class="flex ui-footer-box">
        <div :class="['ui-footer-list', language == 'en' ? 'flex_2' : 'flex_3']">
          <div class="ui-footer-list-title">{{ $t('footer.cooperation.title') }}</div>
            <ul>
              <li class="ui-footer-list-des" v-for="(item, index) in $t('footer.cooperation.list')" :key="index">
                <a v-if="item.url" :href="item.url" v-html="item.title"></a>
                <span v-else v-html="item.title"></span>
              </li>
            </ul>
        </div>
        <div :class="['ui-footer-list', language == 'en' ? 'flex_3' : 'flex_3']">
          <div class="ui-footer-list-title">{{ $t('footer.product.title') }}</div>
          <div class="ui-footer-list-des" v-for="(item, index) in $t('footer.product.list')" :key="index" ><a :href="item.url" v-html="item.title"></a></div>
        </div>
        <div class="ui-footer-list flex_2" v-if="language !== 'en'">
          <div class="ui-footer-list-title">{{ $t('footer.legal_provisions.title') }}</div>
          <div>
            <div class="ui-footer-list-des" v-for="(item, index) in $t('footer.legal_provisions.list')" :key="index" ><a :href="item.url" v-html="item.title"></a></div>
          </div>
        </div>
        <div :span="6" class="ui-footer-list flex_3">
          <div class="ui-footer-list-title">{{ $t('footer.contactUs.title') }}</div>
          <div>
            <div v-for="(item, index) in $t('footer.contactUs.list')" :key="index">
              <a v-if="item.url" class="ui-footer-list-des" :href="item.url" target="_blank" v-html="item.title"></a>
              <!-- <p v-else class="ui-footer-list-des" v-for="($item, $index) in item.title" :key="$index" v-html="$item"></p> -->
              <div v-else class="ui-footer-list-des">
                <p class="fl">{{ item.title }}</p>
                <div class="ilblk">
                  <p v-for="(item, index) in item.des" :key="index" v-html="item"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="['code', language != 'en' ? 'flex_1' : '']">
          <img class="code-img" :src="require('@/assets/images/code.png')" fit='fill' />
          <div class="textc">{{ $t('footer.code') }}</div>
        </div>
      </div>
      <div class="ui-footer-copy">
        <div class="flex justify_content_between">
          <div>{{ $t('footer.bottom.copy') }}</div>
          <div>
            <a class="flex ui-footer-filing fr" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802009609" target="_blank">
              <img :src="require('@/assets/images/ghs.png')" fit='fill' class="fl" />
              <p class="fl">{{ $t('footer.bottom.network') }}</p>
            </a>
            <a class="fl" href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" target="_blank">{{ $t('footer.bottom.ICP') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
.pc .ui-footer{
  color: #ffffff;
  // position: fixed;
  width: 100%;
  bottom: 0;
  height: 400PX;
  background-image: url(../../../assets/images/footer.png);
  background-repeat: no-repeat;
  background-size: 100% 403PX;
  font-size: 14PX;
  // .ui-footer-mask {
  //   position: absolute;
  //   background: rgba(0, 0, 0, 0.8);
  // }
  .ui-footer-box{
    padding: 75PX 0 33PX 0;
    .ui-footer-list{
      .ui-footer-list-title{
        font-size: 16PX;
        color: #ffffff;
        line-height: 38PX;
        padding-bottom: 20PX;
      }
      .ui-footer-list-des{
        line-height: 30PX;
        color: #ffffff;
        display: block;
        a {
          color: #ffffff;
        }
        &:hover a {
          color: #daf3ff;
        }
      }
    }
    .code{
      padding-top: 10PX;
      text-align: center;
      line-height: 44PX;
      .code-img{
        height: 120PX;
        width: 120PX;
        display: inline-block;
      }
    }
  }
  .ui-footer-copy{
    // height: 69PX;
    line-height: 68PX;
    position: absolute;
    width: 80%;
    bottom: 10PX;
    .ui-footer-filing img{
      margin: 24PX 7PX 0 28PX;
      width: 20PX;
      height: 20PX;
    }
    a {
      color: #ffffff;
      &:hover {
        color: #daf3ff;
      }
    }
  }
}
</style>
<style lang="less">
@media screen and (max-height: 986PX) {
  .pc .ui-footer {
    height: 380PX;
    .ui-footer-copy{
      line-height: 48PX;
      .ui-footer-filing img{
        margin: 14PX 7PX 0 28PX;
      }
    }
  }
}
@media screen and (max-width: 1152PX) {
  .pc .ui-footer {
    font-size: 12PX;
  }
}
</style>
